import { lazy, Suspense, useState } from 'react';
import { ArrowUpRight } from 'lucide-react';

import { importarComponente } from '@/components/app/staleChunkRecovery';

// Lazy: o modal tem ~1000 linhas e só carrega quando alguém clica num grupo.
const GroupDetailModal = lazy(() => importarComponente(() => import('./GroupDetailModal'), 'GroupDetailModal'));
const GroupStatusSection = lazy(() => importarComponente(() => import('./GroupStatusSection'), 'GroupStatusSection'));

/**
 * Número do grupo clicável que abre o detalhe do grupo num modal, sem sair da
 * página — venda, lance, comissão, contato, proposta usam este mesmo link.
 *
 * `span` com role, não `<a>`/`<button>`: várias linhas que mostram o grupo já
 * são um `<button>` inteiro, e botão dentro de botão é HTML inválido. O
 * wrapper engole o clique (inclusive os que vêm do modal pelo portal, que no
 * React sobem pela árvore) pra não disparar o onClick da linha/card por fora.
 */
export const GrupoLink = ({ groupNumber }: { groupNumber: number | string }) => {
  const [open, setOpen] = useState(false);
  const numero = Number(groupNumber);

  return (
    <span onClick={(e) => e.stopPropagation()}>
      <span
        role="button"
        tabIndex={0}
        className="text-primary inline-flex cursor-pointer items-center gap-0.5 font-semibold underline underline-offset-2 hover:opacity-80"
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }
        }}
      >
        {String(groupNumber)}
        <ArrowUpRight className="h-[1em] w-[1em]" />
      </span>
      {open && (
        <Suspense fallback={null}>
          <GroupDetailModal
            open
            groupNumber={numero}
            onClose={() => setOpen(false)}
            extraSection={<GroupStatusSection groupNumber={numero} />}
          />
        </Suspense>
      )}
    </span>
  );
};
